module.exports = __webpack_public_path__ + "app/modals/show-wzdx-password-modal.view.html";